import { LoaderFunctionArgs } from "react-router-dom";
import {
  AdminManageCourseResponse,
  PagingResultModel,
} from "../types/adminManageCoursesTypes";
import { apiEndpoints } from "@/services/api/api";

export async function AdminManageCoursesLoader({
  request,
}: LoaderFunctionArgs): Promise<PagingResultModel<AdminManageCourseResponse>> {
  const url = new URL(request.url);
  const page = Number(url.searchParams.get("page") ?? 1);
  const search = url.searchParams.get("search") ?? "";

  const response = await apiEndpoints.getAdminManageCourses({
    pageNumber: page,
    pageSize: 10,
    desc: null,
    orderBy: null,
    search: search,
  });

  if (!response.success) {
    throw Error(response.message);
  }

  return response.data;
}
